import React from 'react';
import PropTypes from 'prop-types';
import { Switch } from 'react-router-dom';
import { Layout } from 'antd/lib';

import RutaAutenticada from '../auth/RutaAutenticada';

import GenerarPlanilla from './planillaEstadistica/GenerarPlanilla';

import * as Roles from '../common/DeclaracionRoles';

class Index extends React.PureComponent {
  render() {
    const { Content } = Layout;

    return (
      <Layout
        style={{
          padding: '0 24px 24px',
        }}
      >
        <Content
          style={{
            padding: '0 24px 24px 24px',
            margin: 0,
          }}
        >
          <Switch>
            <RutaAutenticada
              exact
              path={`${this.props.match.url}/planilla`}
              component={GenerarPlanilla}
              rolesAutorizados={[
                Roles.CONFIGURACION,
                Roles.SUPERVISOR,
                Roles.DGJP_DIRECTOR,
                Roles.ESTADISTICA,
                Roles.DGJP_DIRECTOR,
              ]}
            />
          </Switch>
        </Content>
      </Layout>
    );
  }
}

Index.propTypes = {
  match: PropTypes.object.isRequired,
};

export default Index;
